import React from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Deactivation.css"; // optional CSS styling

const Deactivation = () => {
  const navigate = useNavigate();

  const handleConfirm = async () => {
    const msisdn = Cookies.get("msisdn");
    const serviceName = "Quizbox";

    if (!msisdn) {
      toast.error("Phone number is required.");
      return;
    }

    try {
      const response = await fetch("/deactivation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ msisdn, serviceName }),
      });

      const res = await response.json();
      if (res.code === 0) {
        Cookies.remove("msisdn");
        Cookies.remove("status");
        toast.success("Successfully deactivated!");
        setTimeout(() => {
          navigate("/subscribe");
        }, 1500);
      } else {
        toast.error(res.message || "Deactivation failed.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="deactivation-overlay">
      <div className="deactivation-modal">
        <h3>Do you really want to deactivate QuizBox?</h3>
        <div className="modal-buttons">
          <button onClick={handleConfirm} className="yes-btn">
            Yes
          </button>
          <button onClick={() => navigate("/")} className="no-btn">
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Deactivation;
